export default __webpack_public_path__ + "static/media/cg.384e7dae.svg";